import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'consumo-horas-regalo/';

// Interfaz para ConsumoHorasRegalo
export interface ConsumoHorasRegalo {
    id: number;
    uso_horas_regalo: number;
    espacio_servicio: number;
    precio_plan_servicio: number;
    fecha_inicio: string;
    reservado_desde?: string | null;
    limite_programado?: string | null;
    registrado_por?: number | null;
    sesion_pos?: number | null;
    fecha_fin: string | null;
    duracion_minutos: number;
    minutos_consumidos: number;
    minutos_restantes: number;
    excedente_cobrado: string; // lo devuelve como string decimal
    estado: 'en_curso' | 'finalizado' | 'excedido';
}

// Obtener todos los consumos
export const fetchConsumosHorasRegalo = async (): Promise<ConsumoHorasRegalo[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

// Crear un nuevo consumo (iniciar cronómetro)
export const createConsumoHorasRegalo = async (data: {
    uso_horas_regalo: number;
    espacio_servicio: number;
    precio_plan_servicio: number;
    duracion_minutos?: number; // opcional
}): Promise<ConsumoHorasRegalo> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// Finalizar un consumo (detener cronómetro)
export const finalizarConsumoHorasRegalo = async (id: number): Promise<ConsumoHorasRegalo> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(`${API_URL}${id}/finalizar/`);
        return response.data;
    });
};

// Actualizar un consumo (ej. duración pactada)
export const updateConsumoHorasRegalo = async (
    id: number,
    data: Partial<ConsumoHorasRegalo>
): Promise<ConsumoHorasRegalo> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// Eliminar un consumo
export const deleteConsumoHorasRegalo = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};

// Obtener consumos activos por cliente
export const fetchConsumosActivosPorCliente = async (clienteId: number): Promise<ConsumoHorasRegalo[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}activos_por_cliente/?cliente_id=${clienteId}`);
        return response.data;
    });
};

// Obtener consumos activos por uso_horas_regalo
export const fetchConsumosActivosPorUso = async (usoHorasRegaloId: number): Promise<ConsumoHorasRegalo[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}activos_por_uso/?uso_horas_regalo_id=${usoHorasRegaloId}`);
        return response.data;
    });
};
